import { Contact } from "@models/contact.model";
import { BaseConverter } from "./BaseConverter";
import { ContactDto } from "@dtos/contact.dto";
import { AccomodationConverter } from "./accomodationConverter";

export class ContactConverter extends BaseConverter<Contact, ContactDto> {
    private accomodationConverter = new AccomodationConverter();

    modelToDto(model: Contact): ContactDto {
        return new ContactDto(
            model.id,
            model.whatsapp,
            model.telephoneNumber,
            model.mobileNumber,
            model.email,
            model.facebook,
            model.instagram,
            model.youtube,
            model.tiktok,
            model.website,
            model.airbnb,
            model.booking,  
            model.otherWebsites,    
            model.accomodation? this.accomodationConverter.modelToDto(model.accomodation): undefined
        )
    }

    dtoToModel(dto: ContactDto): Contact {
        return new Contact(
            dto.id,
            dto.whatsapp,
            dto.telephoneNumber,
            dto.mobileNumber,
            dto.email,
            dto.facebook,
            dto.instagram,
            dto.youtube,
            dto.tiktok,
            dto.website,
            dto.airbnb,
            dto.booking,  
            dto.otherWebsites,
            dto.accomodation? this.accomodationConverter.dtoToModel(dto.accomodation): undefined
        )
    }
}